import type { RecordView } from '@kit/sync/types/record-view';
import { useLiveQuery } from 'dexie-react-hooks';
import { replica } from '@/shared/sync/replica';
import type { CollectionName } from './collection-name';

type UseRecordsOptions = {
  readonly deleted?: boolean;
};

/** Live list of a collection (the trash when `deleted`); undefined while loading. */
export function useRecords<T>(
  collection: CollectionName,
  options: UseRecordsOptions = {},
): RecordView<T>[] | undefined {
  const deleted = options.deleted ?? false;
  return useLiveQuery(
    async function load() {
      const views = await replica.list(collection);
      // Records were validated against this collection's schema when written (here and on the server).
      return views.filter((view) => (view.deleted_at !== null) === deleted) as RecordView<T>[];
    },
    [collection, deleted],
  );
}
